import React from "react";
import { useLocation } from "react-router-dom";
import { waLink } from "@/lib/company";
import { useWhatsAppText, WaIcon } from "@/lib/whatsapp";

export const WhatsAppButton = () => {
  const text = useWhatsAppText();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const onDetail = /^\/fahrzeuge\/[^/]+/.test(pathname);
  return (
    <a href={waLink(text)} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn"
      aria-label="Per WhatsApp schreiben"
      className={`group fixed z-40 right-4 lg:right-8 bottom-[calc(84px+env(safe-area-inset-bottom))] lg:bottom-8 items-center gap-0 lg:hover:gap-2.5 h-14 pl-4 pr-4 rounded-full glass border border-line text-ink shadow-[0_14px_40px_-12px_rgba(0,0,0,0.6)] transition-[gap,border-color] duration-300 hover:border-[#25D366]/60 ${onDetail ? "hidden lg:flex" : "flex"}`}>
      <WaIcon size={22} className="text-[#25D366]" />
      <span className="hidden lg:inline-block max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-300 group-hover:max-w-[120px]">
        WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
